const colors = {
    primary: '#27378B',
    secondary: '#F39971',
    error: '#FF2A1E',
    success: '#00860D',
    disable: '#E6E6E6',
    defualt: '#666666',
    white: '#fff',
    none: 'none'
}

type Props = {
    name:keyof typeof IconType,
    title?: string, 
    onClick?:(e: any) => void, 
    className?: string, 
    size?:string, 
    style?: any 
    color?: keyof typeof colors
    fill?: keyof typeof colors | string
}
enum IconType {'target-02', 'check-square-broken','edit-02', 'chevron-up', 'chevron-right', 'chevron-left', 'chevron-down', 'circle', 'trash-01', 'plus-circle', 'x-close',
    'x-circle','paperclip','truck-01', 'download-01', 'file-05', 'check', 'arrow-narrow-down', 'arrow-narrow-up', 'arrow-narrow-left', 'arrow-narrow-right', 'eye', 'eye-off',
    'alert-circle', 'refresh-cw-01'
}

function RonadIcons (props: Props) {
    const {className,name, size, color, fill, ...other} = props
    const defProps = {
        width: size || '24px',
        height: size || '24px',
        stroke: color && colors[color],
        fill: (fill && colors[fill]) ? colors[fill] : fill ,
        ...other
    }

    const style = {
        // height: defProps.height,
        ...props.style
    }

    return (
        // <div className={classes} style={style} title={title} onClick={onClick}>
            <svg {...defProps} className={"svg-icon pointer " + className} >
              <use href={`/sprite.svg#${name}`} />
            </svg>
        // </div>
    )
}

RonadIcons.defaultProps = {
    size: "24px",
    color: 'defualt',
    fill: 'none'
}

export default RonadIcons;
